/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createInitialization } from '../fn/mh-initialization/create-initialization';
import { CreateInitialization$Params } from '../fn/mh-initialization/create-initialization';
import { getInitializationByUserId } from '../fn/mh-initialization/get-initialization-by-user-id';
import { GetInitializationByUserId$Params } from '../fn/mh-initialization/get-initialization-by-user-id';
import { Initialization } from '../models/initialization';
import { modifyInitialization } from '../fn/mh-initialization/modify-initialization';
import { ModifyInitialization$Params } from '../fn/mh-initialization/modify-initialization';

@Injectable({ providedIn: 'root' })
export class MhInitializationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `modifyInitialization()` */
  static readonly ModifyInitializationPath = '/api/mh/initialization/{id}';

  /**
   * Edits a medical history initialization with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyInitialization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyInitialization$Response(params: ModifyInitialization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyInitialization(this.http, this.rootUrl, params, context);
  }

  /**
   * Edits a medical history initialization with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyInitialization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyInitialization(params: ModifyInitialization$Params, context?: HttpContext): Observable<void> {
    return this.modifyInitialization$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createInitialization()` */
  static readonly CreateInitializationPath = '/api/mh/initialization/{id}';

  /**
   * Creates a medical history initialization with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInitialization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInitialization$Response(params: CreateInitialization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createInitialization(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a medical history initialization with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInitialization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInitialization(params: CreateInitialization$Params, context?: HttpContext): Observable<void> {
    return this.createInitialization$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getInitializationByUserId()` */
  static readonly GetInitializationByUserIdPath = '/api/mh/initialization';

  /**
   * Returns medical history initialization for the logged user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInitializationByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInitializationByUserId$Response(params?: GetInitializationByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Initialization>> {
    return getInitializationByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns medical history initialization for the logged user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInitializationByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInitializationByUserId(params?: GetInitializationByUserId$Params, context?: HttpContext): Observable<Initialization> {
    return this.getInitializationByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Initialization>): Initialization => r.body)
    );
  }

}
